import apiClient from "./client";

export async function fetchGuarantorRequirements(includeInactive = true) {
  const { data } = await apiClient.get("/borrowers/guarantors/requirements", {
    params: { include_inactive: includeInactive },
  });
  return data;
}

export async function createGuarantorRequirement(payload) {
  const { data } = await apiClient.post("/borrowers/guarantors/requirements", payload);
  return data;
}

export async function updateGuarantorRequirement(requirementId, payload) {
  const { data } = await apiClient.patch(`/borrowers/guarantors/requirements/${requirementId}`, payload);
  return data;
}

export async function deactivateGuarantorRequirement(requirementId) {
  await apiClient.delete(`/borrowers/guarantors/requirements/${requirementId}`);
}
